import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray, map, startsWith, uniqBy} from 'lodash';
import searchHoc from '../components-app/search-wrapper';

const servicesDataKey = 'networkList';

const networkList = ({onChange, value, id, searchData}) => (
    <Dropdown
        filter={true}
        filterBy="label,value"
        filterPlaceholder="Select Network"
        id={id}
        options={
            isArray(searchData.networks)
                ? map(uniqBy(searchData.networks), network => ({
                      label: startsWith(network.name, ' ') ? `'${network.name}'` : network.name,
                      value: network.name,
                  }))
                : []
        }
        showClear={false}
        style={{width: '300px'}}
        value={value}
        onChange={onChange}
    />
);

networkList.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    searchData: PropTypes.array.isRequired,
    value: PropTypes.string.isRequired,
};

export default searchHoc(networkList, servicesDataKey);
